
// $(document).ready(function(){
 

// var onScroll = function() {
//     $('.sections-slide-show').each(function(index, elem) {
//      if ($(this).offset().top < $(window).scrollTop()) {
//        var difference = $(window).scrollTop() - $(this).offset().top;
//        var half = (difference / 2) +'px';
//         var pos = $(this).find('img').position();
//        $(this).find('img').css('top', half);
//         $(this).next().find('img').css({"border": "0 solid #000"});
//       } else {
//        $(this).find('img').css('top','0');
//       }
//     });
//   };
//   onScroll.apply(window);
//   $(window).on('scroll', onScroll); 
// })

var waitForElsliderbanner = function(selector, callback) {
  if (jQuery(selector).length) {
    console.log('test123');
    console.log(jQuery(selector).length);
    callback();
  } else {
    setTimeout(function() {
      waitForElslider(selector, callback);
    }, 100);
  }
};

waitForElsliderbanner('#slider-main-container-index', function() {
   if ($('#slider-main-container-index').length > 0) {
        var deocraft = `
        <div id="progress-bar--container" class="active-progress">
    <svg viewBox="0 0 100 100">
      <circle id="progress--circle" stroke="#28411B" stroke-width="5.5" cx="50" cy="50" r="44" fill="none" pathLength="100"/>
      <img src="https://cdn.shopify.com/s/files/1/0442/1903/9893/files/Vector_1.png?v=1704390465"/>
    </svg>
</div>`;
    $('#slider-main-container-index').append(deocraft);
  }
})
 $(window).scroll(function () {
    
    if ($('#slider-main-container-index').length > 0) {

      $(function() {
        var hieghtThreshold = $("#slider-main-container-index").offset().top;
        var hieghtThreshold_end  = $("#slider-main-container-index").offset().top +$("#slider-main-container-index").height() - 100 ;
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
        
            if (scroll >= hieghtThreshold && scroll <=  hieghtThreshold_end ) {
                $('body').removeClass('homeHeaderCustomStyle');
            } else {
                $('body').addClass('homeHeaderCustomStyle');
            }
          });
      })
      
      var s = $(window).scrollTop(),
            d = $('#slider-main-container-index').height(),
            c = $(window).height();
            scrollPercent = (s / (d)) * 100;
       if(scrollPercent > 0){
             // jQuery('#progress-bar--container').addClass('active-progress');
       }
       if(scrollPercent > 96){
             // jQuery('#progress-bar--container').removeClass('active-progress');
       }
        
        var position = scrollPercent;
        var progressPath = document.querySelector('.progress-wrap path');
        const meter = document.getElementById("progress--circle");
        
      
    }
});

// Animation function


$(document).ready(function () {
  $(".template-index #MainContent").prepend("<div id='slider-main-container-index'></div>");
  $('#slider-main-container-index').append($('.sections-slide-show'));
  // by sehjad
  // $("<div id='newsecton_fullpage'></div>").insertAfter('#slider-main-container-index');
  $("<div class='sections-slide-show pp-scrollable'></div>").appendTo('#slider-main-container-index');

  //end by sehjad
    
  var interval = setInterval(function () {
    if ($('.sections-slide-show').length > 0) {


      const progressCircle = document.getElementById("progress--circle");
    const radius = '45';//progressCircle.r.baseVal.value;
    const circumference = radius * 2 * Math.PI;

      function animateProgress(duration, targetValue) {
    let start = null;
    const initialOffset = circumference;

    function step(timestamp) {
        if (!start) start = timestamp;

        const elapsed = timestamp - start;
        const progress = Math.min(elapsed / duration, 1);
        const offset = initialOffset - (targetValue / 100 * circumference * progress);

        progressCircle.style.strokeDashoffset = offset;

        if (elapsed < duration) {
            requestAnimationFrame(step);
        }
    }

    requestAnimationFrame(step);
}
    
    // Set the initial dash array and dash offset
    progressCircle.style.strokeDasharray = `${circumference} ${circumference}`;
    progressCircle.style.strokeDashoffset = circumference;

      // by sehjad
      $(".pp-scrollable").append($(".sections-customer-review-block"));
      $(".pp-scrollable").append($(".sections-brand-slider"));
      $(".pp-scrollable").append($(".wrapper-footer"));
      
      // end by sehjad
      
      $('body').removeClass('homeHeaderCustomStyle');
      // $('body').css('overflow','hidden');
      // new fullpage('#slider-main-container-index', {
      //     scrollBar: true,
      //     sectionSelector: ".sections-slide-show",
          

      //   afterLoad: function(section, origin, destination, direction, trigger){
          
      //       const total_slide = document.querySelectorAll('.fp-section').length;  
      //         if((destination === 'down' && section.index === total_slide-2) || (destination === 'down' && section.index === total_slide-1)){
      //           // $("body").removeClass("homeHeaderCustomStyle");    
      //           // $(".header").addClass("header-scrolled");
      //           // $('body').css('overflow','hidden');
      //         }else{
      //           // $("body").addClass("homeHeaderCustomStyle");    
      //           // $(".header").removeClass("header-scrolled");
      //           // $('body').css('overflow','hidden');
      //         }
      //     },
          
          
      //     // afterLoad: function (origin, destination, direction,trigger) {
      //     //   animateProgress(21000, 100);
      //     // }
      //   });


        // pagepilling by sehjad
        pipeSlider();
      // end pagepelling by sehjad

      
        // initReviewSlider();
        // brandslider();
        clearInterval(interval);
    }
  });

   
// change background image for mobile view on home page
  // $('.shopify-section').each(function(index) { 
  //   var image = $(this).find('.slide-mobile img');console.log(image.attr('srcset'));
  //   var backgroundDiv = $(this).find('.slideshow-wrapper');
  //   if(image.length >= 1){
  //       if(image.attr('srcset')){
  //           var imageUrl = image.attr('srcset').split("?")[0];    
  //       }
  //       if(image.attr('data-srcset')){
  //           var imageUrl = image.attr('data-srcset').split("?")[0];    
  //       }
  //       backgroundDiv.css('background-image', "url("+imageUrl+")");
  //     }
  //   });

  $('.shopify-section').each(function(index) {
    var image = $(this).find('.slide-mobile img');
    var backgroundDiv = $(this).find('.slideshow-wrapper');
    if ($(window).width() <= 767 && image.length >= 1) {
        var imageUrl;
        if (image.attr('srcset')) {
            imageUrl = image.attr('srcset').split("?")[0];
        }
        if (!imageUrl && image.attr('data-srcset')) {
            imageUrl = image.attr('data-srcset').split("?")[0];
        }
        if (imageUrl) {
            backgroundDiv.css('background-image', "url(" + imageUrl + ")");
        }
    }
});

  
});

/*
 $(document).ready(function() {
   var windowHeight = $(window).height(),
     gridTop = windowHeight * .5,
     gridBottom = windowHeight * .9;
   $(window).on('scroll', function() {
     $('#slider-main-container-index .sections-slide-show').each(function() {
         section = $(this).closest('#slider-main-container-index');
       var thisTop = $(this).offset().top - $(window).scrollTop(); // Get the `top` of this `li`
       if (thisTop >= gridTop) {        
           console.log('yes');
             scrollThere($(this).next(), 500);
        break;
       }
     });
   });
 });
*/

$(document).ready(function(){
         let filterHeight = $('.page-sidebar').height();
         let headerHeight = $('.header').height();
        $(':root').css({'--filter-height': filterHeight+'px'})
        $(':root').css({'--header-height': headerHeight+'px'})      
    })

$(window).on('resize',function(){
       let filterHeight = $('.page-sidebar').height();
         let headerHeight = $('.header').height();
        $(':root').css({'--filter-height': filterHeight+'px'})
        $(':root').css({'--header-height': headerHeight+'px'})  
})
// function slickslidercall(){
//   if($('.card-product .card-media').length > 0){
//       $('.card-product .card-media').slick({
//       dots: false,
//       arrows:true,
//       infinite: true,
//       speed: 300,
//       slidesToShow: 1,
//       slidesToScroll: 1
//     })
//   console.log('ests')
// }
// }       

//setInterval(slickslidercall, 1000);


// $(function() {
//  setInterval(function() {
//         if($('.card-product .card-media').length > 0){
//       $('.card-product .card-media').slick({
//       dots: false,
//       arrows:true,
//       infinite: true,
//       speed: 300,
//       slidesToShow: 1,
//       slidesToScroll: 1
//     })
// }
//  }, 10);
// });


/* slickgoto code start here */



/* slickgoto code end here */

$(window).on('resize',function(){
  if ($(window).width() < 768) {
    $('.show-category-section').parents('.container').removeClass('showing-category');
   $('.show-category-section').parents('.container').addClass('showing-category');
     $(document).on("click", ".show-category-section", function(e) {
       $(this).parents('.container').removeClass('mobile-category-hide');
     })
  }
}).trigger('resize');
 $(document).on("click", ".show-category-section", function(e) {
  //$(this).find('show-cat').css(display, none);
  $(this).parents('.container').toggleClass('showing-category');

    $('.card-product .card-media').each(function() {
        if($(this).hasClass('slick-initialized')) {
          $(this).slick('unslick');
          $(this).slick({
            dots: false,
            arrows:true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            
  
            
          })
        }
    })
})


$(document).on('change', '.sidebarBlock.js-filter input[type="checkbox"],#SortBy', function(e) {
collection_product_filter()
})

$(document).on('click', '.reset-price-input-field', function(e) {  
  $("#min_numberField").val('');
  $("#max_numberField").val(''); 
  collection_product_filter()
})

let keyupTimer_min;
$(document).on('keypress', '#min_numberField', function(e) {  
            clearTimeout(keyupTimer_min);
            keyupTimer_min = setTimeout(function () {
                  collection_product_filter()
            }, 1000);
});

let keyupTimer_max;
$(document).on('keypress', '#max_numberField', function(e) {  
            clearTimeout(keyupTimer_max);
            keyupTimer_max = setTimeout(function () {
                  collection_product_filter()
            }, 1000);
});

function collection_product_filter(){
  $("#CollectionFiltersForm .collection-filters__item .sidebarBlock:first-child input[type=checkbox]:checked").removeAttr('checked');
  setTimeout(function(){
  document.body.classList.add('has-halo-loader');
var arr1 = [];
  var data_section_id = $('#main-collection-product-grid').attr('data-id')
$(".sidebarBlock.js-filter input[type=checkbox]:checked").each(function(){
    console.log($(this).val());
    key=$(this).val().replaceAll(/ /g,"+");
    console.log('dmeo '+$(this).attr("name"))
    arr1.push($(this).attr("name")+"="+key);
});
  var get_min_price_filter = $('#min_numberField').val();
  var get_max_price_filter = $('#max_numberField').val();
arr1.push('filter.v.price.gte='+get_min_price_filter)  
arr1.push('filter.v.price.lte='+get_max_price_filter)  
arr1.push('sort_by='+$('#SortBy').val())  
var party = arr1.join("&")
//console.log(party)

const url = `  ${window.location.pathname}?section_id=${data_section_id}&${party}`;

        fetch(url)
        .then(response => response.text())
        .then((responseText) => {
            const html = responseText;
            var dmo = $(html).find('#main-collection-product-grid').html();
            var filter_bllcks =  $(html).find('#CollectionFiltersForm');
          
          $('#CollectionFiltersForm').html(filter_bllcks)
            $('#main-collection-product-grid').html(dmo)

         $('#min_numberField').val(get_min_price_filter);
         $('#max_numberField').val(get_max_price_filter);
                
            $(".card-product .card-media").each(function(){                
                if (!$(this).hasClass('slick-initialized')){
                   $(this).slick({
                      dots: false,
                      arrows:true,
                      infinite: true,
                      speed: 300,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    })
                }
            })
        });
       var current_url=window.location.href
        var new_filtered_url_arr=current_url.split('?')[0];
window.history.replaceState({path:new_filtered_url_arr},'',`?${party}`);
document.body.classList.remove('has-halo-loader');
},500)
}

function restrictNumberprice(e) {
  var newValue = this.value.replace(new RegExp(/[^\d]/, 'ig'), "");
  this.value = newValue;
}

var min_price_filter = document.querySelector('#min_numberField');
var max_price_filter = document.querySelector('#max_numberField');

if(typeof min_price_filter != "undefined" && min_price_filter != null && min_price_filter != ""){
  min_price_filter.addEventListener('input', restrictNumberprice);
}
if(typeof max_price_filter != "undefined" && max_price_filter != null && max_price_filter != ""){
  max_price_filter.addEventListener('input', restrictNumberprice);
}


// code for add size chart find here text afte size option in product page 

var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};

waitForEl('.rio-hide-scrollbar', function() {
  $(".rio-hide-scrollbar").each(function() {
    var txt = $(this).data('option');
    if ($(this).data('option') == "Size") {
      $( '<div class="find-my-size-link">Size Guide</div>' ).insertBefore(this);
    }
})
});

waitForEl('.rio-product-option-title', function() {
  $(".rio-product-option-title").each(function() {
    var txt = $(this).text();
    if ($(this).text() == "SELECT SIZE") {
      $( '.tfc-fitrec-product' ).insertAfter(this);
    }
})
});

  
  $(document).on('click','.find-my-size-link',function(){  
  $('.size-guide-popup').addClass('show');
  $('.size-chart-bg').addClass('is-size-chart-open');
  $('body').addClass('is-size-chart-active');
})

   $(document).on('click','.size-chart-bg, .size-chart-popup-close',function(){         
      $('.size-guide-popup').removeClass('show');
      $('.size-chart-bg').removeClass('is-size-chart-open');
      $('body').removeClass('is-size-chart-active');
  })
  
  
 $('.size-tabing span').click(function(){
     $(this).addClass('active').siblings().removeClass('active');
     var ddd = $(this).attr('data-table-name');
     console.log(ddd)
     var sg = $('.size-guide-inches').attr('data-table-name');
     if(sg == ddd){
         //console.log('dddddd')
         $('.size-guide-inches').show();
         $('.size-guide-centimeter').hide();
     }else{
         $('.size-guide-centimeter').show();
         $('.size-guide-inches').hide();
     }
 })



$(document).on('click','.mini-cart-close-icon',function(){
    $('.astor-cart').hide();    
})

$(document).ready(function(){
  $("#mySearchFunc, #mySearchFuncShippingPolicy, #mySearchFuncRefundPolicy, #mySearchFuncTermsOfService").keyup(function () {
    var filter = jQuery(this).val().toLowerCase();
    $(".faqs-body .faqs-row .faqs-item").each(function () {
        var text = jQuery(this).text().toLowerCase();
        if (text.indexOf(filter) == -1) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });
});
})

$(document).ready(function(){
if($('.sections-slide-show').length > 0){
  $('body').removeClass('homeHeaderCustomStyle');
  // home slider auto slide start
//   function pride10(){
//     $.fn.isInViewport = function() {
//           var elementTop = $(this).offset().top;
//           var elementBottom = elementTop + $(this).outerHeight();
//           var viewportTop = $(window).scrollTop();
//           var viewportBottom = viewportTop + $(window).height();
//           return elementBottom > viewportTop && elementTop < viewportBottom;
//     };
    
//     $('.sections-slide-show').each(function() {
//         if ($(this).isInViewport()) {
//              var tag = $(this).next();
//              $target = tag;
//              if (tag.hasClass('sections-slide-show')) {
//                $('body').removeClass('homeHeaderCustomStyle');
//                   $('html, body').animate({
//                   scrollTop: $target.offset().top
//                   }, 1000);
//                  //console.log(tag.attr('id'));
//              }else{
//                  $('body').addClass('homeHeaderCustomStyle');
//                   $('html, body').animate({
//                   scrollTop: $('#slider-main-container-index').next().offset().top
//                   }, 1000);  
//              }
//         }
//       });
// }
// setInterval(pride10, 8000);
    // home slider auto slide end
}
//let tag = $('.sections-slide-show');
function scrollslide() {
      $.fn.isInViewport = function() {
          var elementTop = $(this).offset().top;
          var elementBottom = elementTop + $(this).outerHeight();
          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();
          return elementBottom > viewportTop && elementTop < viewportBottom;
      };
      
      // -----------------

      if ($('.shopify-section').isInViewport()) {
        console.log(this);     
        var dom = $('.shopify-section');
        if(dom.hasClass('sections-slide-show')){
          $('body').removeClass('homeHeaderCustomStyle');
          //console.log('slideshow in viewport');
          tag = tag.next();
          $target = tag;
          if(tag.hasClass('sections-slide-show')) { 
            $('body').removeClass('homeHeaderCustomStyle');
            console.log('next element has slideshow class');
            $('html, body').animate({
            scrollTop: $target.offset().top
            }, 50);          
          } else {
            $('body').addClass('homeHeaderCustomStyle');
          }
        }
      //  let islastslide = false;
       // tag = tag.next();
        //  $target = tag;
         //  if(tag.hasClass('sections-slide-show')) { 
         //      $('html, body').animate({
         //        scrollTop: $target.offset().top
         //        }, 500);
         // //   islastslide = false;  
         //    console.log('next element has slideshow class');
         //  }else{
         // //   islastslide = true;           
         //  } 
        // if(!islastslide){      
        //   console.log('checking');
        //       setTimeout(function(){
        //       $('html, body').animate({
        //       scrollTop: $target.offset().top
        //       }, 500);
        //       }, 200);
        //     }
      }
}
//setInterval(scrollslide, 4000);

  
 
$('.tab-menu').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1
})
$('.megamenu_banner_images').slick({
  dots: true,
  arrows:false,
  infinite: false,
  speed: 300,
  slidesToShow: 2.5,
  slidesToScroll: 1,
    slide: 'div',
    rows: 0
})

$('.tab-menu .inner-menu-item a').on('click', function(){
  var target = $(this).attr('data-rel');
  var image_target = $(this).attr('data-img-tab');
  $('.tab-menu .inner-menu-item a').removeClass('active');
  $(this).addClass('active');  
  if ( $("#"+target).children().length > 0 ) {
         if($('.megamenu_banner_images').hasClass('slick-initialized')) {
          $('.megamenu_banner_images').slick('unslick');
          $('.megamenu_banner_images').slick({
            dots: false,
            arrows:true,
            infinite: true,
            speed: 300,
            slidesToShow: 2.5,
            slidesToScroll: 1
          })
        }
    $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
  }else{
    $(".tab-box").hide();
  }    
});
setTimeout(function() {
$('#Search-In-Modal').val('');
$('#Search-In-Modal-Mobile').val('');
  
}, 100);
 let textInput = document.getElementById('Search-In-Modal');
      let timeout = null;
      textInput.addEventListener('focus', function (e) {
        call_result();
      })
      textInput.addEventListener('keyup', function (e) {
        call_result();
      })

  let textInput_mobile_search = document.getElementById('Search-In-Modal-Mobile');
      let timeout_mobile_search = null;
      textInput_mobile_search.addEventListener('focus', function (e) {
        call_result_mobile_search();
      })
      textInput_mobile_search.addEventListener('keyup', function (e) {
        call_result_mobile_search();
      }) 


  
function call_result(){
  //console.log('run')
 clearTimeout(timeout); 
      timeout = setTimeout(function () {
        var search_input = textInput.value;
          if(search_input.length > 0) { 
            var q = $('#Search-In-Modal').val();
            var b = '&type=product'
              $.ajax('/search?q=' + q + b,{
              type: 'GET',
              dataType: 'html', // added data type
              success: function(response) {
                  // console.log(response);
                var markup1 =$(response).find('.productListing .product');          
                var params_search = []; 
                //console.log(markup1);       
                var sort_dates = params_search.sort((a, b) => b - a);  
                let prof = "";
                let alax = ""; 
                var k = 0;                  
                if(markup1.length > 0 ){
                      markup1.each(function(i,v) { 
                                var blog_img = $(this).find('.card-product__wrapper .product-image img').attr('src');
                                var blog_url = $(this).find('.card-product__wrapper .product-image').attr('href')
                                var blog_title = $(this).find('.card-information__wrapper .card-title').attr('data-product-title');                                   
                        
                                alax += `<li class="list-group-item"><a href="${blog_url}" class="mb-0"><div class="image-parent mr-3"><img class="img-fluid" src="${blog_img}"/></div><div class="search-blog-title">${blog_title}</div></a></li>`                                                                                                                                                                
                      })    
                   $('#searchResults').html(alax);
                  $("#searchResults").append(
                  '<li class="list-group-item search_page_result_link"><a href="/search?q='+q+''+b+' ">search for more results of "'+ q +'"</a></li>'
                  );
                  $('.result_box').css('display','block');
                }else{
                    $("#searchResults").empty().append(
                      '<li class="list-group-item list-group-item-action d-flex align-items-center"><small>No Results Found</small></li>'
                    );
                    $('.result_box').css('display','block')
              }
            }
          });  
          }else{
      $("#searchResults").empty();
    }
}, 100);
}

function call_result_mobile_search(){
  //console.log('run mobile search')
clearTimeout(timeout_mobile_search); 
      timeout_mobile_search = setTimeout(function () {
        var search_input_mobile = textInput_mobile_search.value;
          if(search_input_mobile.length > 0) { 
            var q = $('#Search-In-Modal-Mobile').val();
            var b = '&type=product'
              $.ajax('/search?q=' + q + b,{
              type: 'GET',
              dataType: 'html', // added data type
              success: function(response) {
                  // console.log(response);
                var markup1 =$(response).find('.productListing .product');          
                var params_search = []; 
                //console.log(markup1);       
                var sort_dates = params_search.sort((a, b) => b - a);  
                let prof = "";
                let alax = ""; 
                var k = 0;                  
                if(markup1.length > 0 ){
                      markup1.each(function(i,v) { 
                                var blog_img = $(this).find('.card-product__wrapper .product-image img').attr('src');
                                var blog_url = $(this).find('.card-product__wrapper .product-image').attr('href')
                                var blog_title = $(this).find('.card-information__wrapper .card-title').attr('data-product-title');                                   
                        
                                alax += `<li class="list-group-item"><a href="${blog_url}" class="mb-0"><div class="image-parent mr-3"><img class="img-fluid" src="${blog_img}"/></div><div class="search-blog-title">${blog_title}</div></a></li>`                                                                                                                                                                
                      })    
                   $('#searchResults_mobile').html(alax);
                  $("#searchResults_mobile").append(
                  '<li class="list-group-item search_page_result_link"><a href="/search?q='+q+''+b+' ">search for more results of "'+ q +'"</a></li>'
                  );
                  $('.result_box').css('display','block');
                }else{
                    $("#searchResults_mobile").empty().append(
                      '<li class="list-group-item list-group-item-action d-flex align-items-center"><small>No Results Found</small></li>'
                    );
                    $('.result_box').css('display','block')
              }
            }
          });  
          }else{
      $("#searchResults_mobile").empty();
    }
}, 100);
}

$('.close-search-popop, .halo-sidebar-close').on('click', function(){
    $('#Search-In-Modal').val('');
  $("#searchResults").empty();
  $('#Search-In-Modal-Mobile').val('');
   $("#searchResults_mobile").empty();
})  
});  


var waitForElslider = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForElslider(selector, callback);
    }, 100);
  }
};

waitForElslider('.product .rio-media-gallery .pwzrswiper-slide', function() {
  $(".product .rio-media-gallery .pwzrswiper-slide").each(function() {
    var data_img_alt = $(this).find('img').attr('alt')    
    if (typeof data_img_alt != 'undefined') {
      var amp_data_img_alt  = data_img_alt.split('||||')[0];
      console.log(amp_data_img_alt);
        if(amp_data_img_alt != ""){
          $(this).find('img').after('<div class="data-custom-alt-data"><span><img src="https://cdn.shopify.com/s/files/1/0442/1903/9893/files/Sparkle.png?v=1704210539"></span>'+amp_data_img_alt+'</div>');
        }
      }
})
});

$(document).on("click","div[data-option-value]",function() {
  setTimeout(function(){
    $(".product .rio-media-gallery .pwzrswiper-slide").each(function() {
    var data_img_alt = $(this).find('img').attr('alt')    
    if (typeof data_img_alt != 'undefined') {
      var amp_data_img_alt  = data_img_alt.split('||||')[0];
      console.log(amp_data_img_alt);
        if(amp_data_img_alt != ""){
          if($(this).find('.data-custom-alt-data').length == 0){
            $(this).find('img').after('<div class="data-custom-alt-data"><span><img src="https://cdn.shopify.com/s/files/1/0442/1903/9893/files/Sparkle.png?v=1704210539"></span>'+amp_data_img_alt+'</div>');
          }
        }
      }
})
  },300)
}) 
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 1) {
        $(".header").addClass("header-scrolled");
      
    }
  else{
    $(".header").removeClass("header-scrolled");
  }
}); //missing );



  $(document).on("click",".select__select.collection-fil-ters__sort",function() {
    console.log('onload load')
    $('.sidebarBlock.js-filter').find('.sidebarBlock-contentWrapper').hide();
    $('.sidebarBlock.js-filter').removeClass('sidebarBlock-open-selector');
    $('.sidebarBlock.js-filter').find('.sidebarBlock-heading').removeClass('is-clicked');
    })
    
$(document).ready(function() { 

    $('body').addClass('enable-swatch-change');

//     $(document).on("click", ".swatch-label", function(e) {
//     var img = $(this).find('span').attr('data-variant-img');
//     var slick_parent = $(this).parents('.product').find('.slick-track .product-image img')
//     $(slick_parent).each(function (e) {
//       var dmo = $(this).attr('src');
//       if(dmo == img){
//         var indexVal = $(this).attr('data-slick-index')
//         $(this).parents('.product').find('.card-media').slick('slickGoTo', indexVal);
//       }
//     })
// })
  
    $(document).on("click",".card-swatch .swatch-label",function() {
      
       $(this).parents('.swatch').find('.swatch-label').removeClass('is-active');
      $(this).addClass('is-active');
          //  console.log($('.swatch-label.is-active').attr('data-value'))
     
         //   console.log('helllll');
            var swatch_value = $(this).attr('data-value');
     // console.log('********'+swatch_value)
            var coll_grid_opt_val = '.group-image-'+swatch_value;
        //    $(this).parents('.card-media').slick('slickFilter',coll_grid_opt_val);
      //$(this).parents(".card").find('.card-media').slick('unslick');
      let is_separate = false;
      var jpt = $(this);
      let main_rr = $(this).parents('.card').find('.card-media .product-image');   
       $(main_rr).each(function (im,ex) {  
          if($(ex).hasClass('color-seperated-variant')){
                  is_separate = true;
          }
           
       })
  //   console.log(is_separate)
      if(is_separate){      
            //   console.log(data-variant-id)
   //   console.log('$$$$$$'+coll_grid_opt_val)
        if($(this).parents(".card").find(coll_grid_opt_val).hasClass("slick-active")){
          console.log(coll_grid_opt_val);
          console.log('slick actived');
        }else{
      $(this).parents(".card").find('.card-media').slick('slickUnfilter');
      $(this).parents(".card").find('.card-media').slick('slickFilter',coll_grid_opt_val);
       var getslickindex = $(this).parents(".card").find('.card-media .slick-slide:nth-child(0)').attr('data-slick-index');
         $(this).parents(".card").find('.card-media').slick('slickGoTo', getslickindex);
        }

              // console.log(getslickindex);

      //     console.log('dddd')
  
      } 
  //    console.log('okkkk');
        // if($('.demo1234567').hasClass('color-seperated-variant')){
        //       var coll_grid_opt_val = '.group-image-'+swatch_value;
        //       console.log('------------------- '+coll_grid_opt_val)
        //           //  $(".slider").slick('slickFilter','.yellow');
        //         //var jpt = $(this);
        //         // let btc_dom = $(jpt).find('.swatch-label').attr('data-value');
        //         // let main_rr = $(jpt).parents('li.product').find('.product-image');   
        //         //     $(main_rr).each(function () {                 
        //         //         console.log(this)
        //         //       $(this).hide();               
        //         //       var product_image_alt = $(this).attr('data-alt');
        //         //       if(btc_dom == product_image_alt){
        //         //         console.log('ddd = '+btc_dom)
        //         //         $(this).show();
        //         //       } 
        //         //     })
        // }

         
        var selectedswatchvariantid = $(this).parents('.swatch').find('.swatch-label.is-active').attr('data-variant-id');
   //   console.log(selectedswatchvariantid)
       $(this).parents('.card').find('a.product-image').each(function(){ 
            var oldUrl = $(this).attr("href"); // Get current url
       //  console.log('old url', oldUrl);
            var newUrl = oldUrl.replace(oldUrl.split('variant=')[1],selectedswatchvariantid)
       //  console.log(newUrl)
            $(this).attr("href", newUrl); 
        });
       
      
         })
  
  // $('.card .swatch-label.is-active').trigger('click');


    })

$(document).ready(function(){
  if(cookieAnnouncemenClosed == 'closed' || $(".announcement-bar").length == 0){
    $("body").addClass("hide-bar"); 
     
  }
$(".announcement-close").click(function(){
  $("body").addClass("hide-bar");
})
  });

// by sehjad

function pipeSlider(){
  !(function () {
            var e = $(".page-head.page-head--no-scroll-listen"),
                o = e.find(".call-to-action"),
                n = $(".sections-slide-show").length - 1;

            $("#slider-main-container-index").pagepiling({
                menu: null,
                direction: "vertical",
                scrollingSpeed: 200,
                easing: "swing",
                loopBottom: true,
                loopTop: true,
                css3: !0,
                scrollBar: true,
                scrollOverflow: true,
                scrollOverflowReset: true,
                navigation: {
			    	'position': 'right',
			   		'tooltips': []
			   	},
                normalScrollElements: null,
                //normalScrollElementTouchThreshold: 1,
                //touchSensitivity: 1,
                keyboardScrolling: !0,
                sectionSelector: ".sections-slide-show",
                animateAnchor: !1,
                onLeave: function (a, l, t) {
                    $(".header").addClass("header-scrolled");
                    if(l === 5){
                        jQuery('body').addClass('homeHeaderCustomStyle');
                        jQuery('#progress-bar--container').removeClass('active-progress');
                    }
                    else{
                        jQuery('body').removeClass('homeHeaderCustomStyle');
                        jQuery('#progress-bar--container').addClass('active-progress');
                    }
                    // "down" == t && a == n
                    //     ? (e.removeClass("page-head--no-start-bg"),
                    //         o.addClass("call-to-action--alt"))
                    //     : "up" == t &&
                    //     a == n + 1 &&
                    //     (e.addClass("page-head--no-start-bg"),
                    //         o.removeClass("call-to-action--alt")),
                    //     "down" == t
                    //         ? $(".page-progress__item--index").animate(
                    //             { width: 20 * a + "%" },
                    //             700
                    //         )
                    //         : "up" == t &&
                    //         $(".page-progress__item--index").animate(
                    //             { width: 20 * (a - 2) + "%" },
                    //             700
                    //         );
                },
                afterRender: function () {
                  
                    
                },
            });
    brandslider();
        })();
}


function initReviewSlider() {
  var policyBlock = $("[data-review-slider]");
  policyBlock.each(function () {
    var self = $(this),
      rows = parseInt(self.data("row")),
      row_tablet = rows > 1 ? parseInt(rows - 1) : 1;
    self.not(".slick-initialized") &&
      self.slick({
        slidesToShow: rows,
        slidesToScroll: 1,
        autoplay: !1,
        dots: !0,
        speed: 800,
        infinite: !0,
        nextArrow: window.arrows.icon_next,
        prevArrow: window.arrows.icon_prev,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: !1,
              dots: !0,
              slidesToShow: row_tablet,
            },
          },
          {
            breakpoint: 992,
            settings: {
              arrows: !1,
              dots: !0,
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: !1,
              dots: !0,
              slidesToShow: 1,
            },
          },
        ],
      });
  });
}

function brandslider() {
  $("[data-brands-slider]").each(function () {
    var self = $(this),
      dataArrows = self.data("arrows"),
      dataDots = self.data("dots"),
      itemsToShow = parseInt(self.data("rows")),
      itemTotal = self.find(".halo-item").length;

    if (self.not(".slick-initialized")) {
      self.slick({
        slidesToShow: itemsToShow,
        slidesToScroll: 1,
        dots: dataDots && itemTotal > itemsToShow,
        infinite: true,
        speed: 800,
        nextArrow: window.arrows.icon_next,
        prevArrow: window.arrows.icon_prev,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              arrows: dataArrows,
              dots: dataDots && itemTotal > 4,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: dataArrows,
              dots: dataDots && itemTotal > 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: dataArrows,
              dots: dataDots && itemTotal > 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              get slidesToShow() {
                return (this.slidesToShow = self.data("rows-mobile"));
              },
              get slidesToScroll() {
                return (this.slidesToScroll = self.data("rows-mobile"));
              },
              arrows: dataArrows,
              dots: dataDots && itemTotal > parseInt(self.data("rows-mobile")),
            },
          },
        ],
      });
    }
  });
}
// end by sehjad




$('.item-content').on('click',function () {    
   if($(this).hasClass('opend')) {    
        $(this).removeClass('opend')
   }else{
       $('.item-content').removeClass('opend')
        $(this).addClass('opend')
   }
})

$('.PwzrGrid-root-111 div[role="button"]').on('click',function(e){
    var color = $(this).attr('aria-label');
    console.log(color);
    $('[data-option="Color"]').find('.PwzrGrid-item-113').removeClass('active');
    // $(this).parents('.PwzrGrid-item-113').addClass('active');
    $('.PwzrBox-root-214').html(color);
});
$(document).ready(function(e){
  $('.PwzrGrid-root-111[data-option="Color"] .PwzrGrid-item-113:first-child').addClass('active');
  $('[aria-label="Color"] .PwzrGrid-root-111.PwzrGrid-item-113.active').find('div[role="button"]').click();
  setTimeout(function(e){
    var color = $('.PwzrGrid-root-111[data-option="Color"] .PwzrGrid-item-113.active').find('div[role="button"]').attr('aria-label');
    $('.PwzrBox-root-214').html(color);
  },200)
})
$('.productListing.productGrid .product .card-information .card-swatch .item .swatch-label').on('click',function(e){
  var color = $(this).attr('data-value');
  $(this).parents('.card-swatch').find('.select_swatch').html(color);
})


